import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import MappingCreatableSelect from "components/select/mappingCreatableSelect";

OptionValueList.propTypes = {
    valuesList: PropTypes.arrayOf(PropTypes.object),
    id: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onCreateOption: PropTypes.func,
    defaultInputValue: PropTypes.string,
};

function OptionValueList({valuesList, id, onChange, onBlur, onCreateOption, defaultInputValue}) {
    return (
        <MappingCreatableSelect
            id={`attribute_${id}`}
            options={valuesList}
            placeholder={<FormattedMessage id={'mapper.select.placeholder'} />}
            defaultInputValue={defaultInputValue}
            onChange={onChange}
            onBlur={onBlur}
            onCreateOption={onCreateOption}
        />
    );
}

export default OptionValueList;
